// removed by extract-text-webpack-plugin
module.exports = {"Box":"_oKPL4","FlightDuration":"_2-KOJ","TakeOffBox":"_yQjGN","LandingBox":"_CkSml","RowOne":"_1qcx8","RowTwo":"_3a1xf","RowThree":"_1MzyL","FlightImage":"_3OqdG","FlightTime":"_2W9Df","FlightCityHalf":"_3cgvF","FlightDate":"_3QTak"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/Tuple/TupleInner/FlightInfo/FlightInfoBoxInnerRight/FlightInfoBoxInnerRight.scss
// module id = 516
// module chunks = 0